import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import AddIcon from '@mui/icons-material/Add';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import AccordionController from 'components/AccordionController';
import Dialog from 'components/Dialog';
import AssignHotelToPackageDialog from 'components/AssignHotelToPackageDialog';
import PackageEditAccomodationHotel from 'components/PackageEditAccomodationHotel';

import { PackageEditAccommodation_package$key } from '__generated__/PackageEditAccommodation_package.graphql';
import { PackageEditAccommodation_data$key } from '__generated__/PackageEditAccommodation_data.graphql';
import PackageEditAccomodationPrices from 'components/PackageEditAccomodationPrices';

type Props = {
  package: PackageEditAccommodation_package$key;
  data: PackageEditAccommodation_data$key;
};

const PackageEditAccommodation: FC<Props> = props => {
  const pack = useFragment(
    graphql`
      fragment PackageEditAccommodation_package on Package {
        hotel {
          id
        }

        ...PackageEditAccomodationHotel_package
        ...PackageEditAccomodationPrices_package
        ...AssignHotelToPackageDialog_package
      }
    `,
    props.package
  );

  const data = useFragment(
    graphql`
      fragment PackageEditAccommodation_data on Query {
        ...AssignHotelToPackageDialog_data
        ...PackageEditAccomodationPrices_data
      }
    `,
    props.data
  );

  const { hotel } = pack;

  if (!hotel) {
    return (
      <Alert
        variant="filled"
        severity="warning"
        action={
          <Dialog
            fullWidth
            maxWidth="sm"
            activateButton={open => (
              <Button
                startIcon={<AddIcon />}
                color="inherit"
                size="small"
                onClick={open}>
                Pridėti
              </Button>
            )}>
            <AssignHotelToPackageDialog package={pack} data={data} />
          </Dialog>
        }>
        Šis pasiūlymas dar neturi viešbučio
      </Alert>
    );
  }

  return (
    <AccordionController id="packageEditAccommodation">
      <PackageEditAccomodationHotel package={pack} />
      <PackageEditAccomodationPrices package={pack} data={data} />
    </AccordionController>
  );
};

export default PackageEditAccommodation;
